/*
 * Input Quantity directive
 * Version 1.0.0
 * Octave
 * Modified from <https://github.com/Firestitch/angular-counter>.
 **/

(function () {
  'use strict';

  angular
  .module('component.input.quantity', [])

  .component('inputQuantity', {
    require: {
      productCtrl: '?^^productDetail'
    },
    bindings: {
      id: '<?idProduct',
      min: '<?',
      step: '<?',
      quantity: '<?',
      width: '<?',
      size: '@?',
      btnClass: '@?',
      fieldTabindex: '@',
      keyEnter: '&?',
      action: '&?'
    },
    templateUrl: 'component.input-quantity.tpl',
    /* @ngInject */
    controller: ["$scope", function ($scope) {
      var ctrl = this,
        unwatch;

      ctrl.$onInit = function () {
        ctrl.min = ctrl.min === undefined ? 1 : ctrl.min;
        ctrl.step = ctrl.step || 1;
        ctrl.step = ctrl.step === 0 ? 1 : ctrl.step;

        setItemQuantity(ctrl.quantity || ctrl.min);

        ctrl.groupClass = ctrl.size ? 'input-group input-group-' + ctrl.size : 'input-group';
        ctrl.btnClass = ctrl.btnClass ? ctrl.btnClass : 'btn-default';

        if (ctrl.width) {
          ctrl.getWidth = function () {
            return {'width': ctrl.width + 'px'};
          };
        }
        if (ctrl.keyEnter) {
          ctrl.keypress = function (event) {
            if (event.which === 13) {
              event.preventDefault();
              $(event.target).blur();
              ctrl.keyEnter();
            }
          };
        }
        if (ctrl.action) {
          unwatch = $scope.$watch('$ctrl.quantity', function (value) {
            ctrl.action({id: ctrl.id, qty: value});
          });
        }

      };

      ctrl.$onDestroy = function () {
        if (typeof unwatch !== 'undefined') {
          unwatch();
        }
      };

      ctrl.minus = function () {
        ctrl.quantity = setValue(ctrl.quantity - ctrl.step);
      };

      ctrl.plus = function () {
        ctrl.quantity = setValue(ctrl.quantity + ctrl.step);
      };

      ctrl.blurred = function () {
        ctrl.quantity =  setValue(ctrl.quantity);
      };

      ctrl.changed = function () {
        ctrl.quantity =  setValue(ctrl.quantity);
      };

      // Scopes

      $scope.$on('rb.input.quantity:clearInput', function () {
        ctrl.quantity = ctrl.min;
      });
      $scope.$on('rb.input.quantity:changeInput', function (event, newval) {
        ctrl.quantity = newval;
      });

      // Functions

      function setItemQuantity(value) {
        ctrl.quantity = value < ctrl.min ? ctrl.min : value;
        if (ctrl.productCtrl) {
          ctrl.productCtrl.setInputQuantity(ctrl.quantity);
        }
      }

      function setValue(val) {
        if (val === '') {
          return ctrl.min;
        }
        val = parseInt(val);
        if (!isNaN(val)) {
          if (ctrl.min > val) {
            val = ctrl.min;
            return val;
          }
          return val;
        }
        val = ctrl.min || 0;
        return val;

      }

    }]
  });

})();
